import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {plano} from "../../models/plano";
import {Navigation} from "../../services/navigation.service";
import {ProyectoService} from "../../services/proyecto.service";
import {UserService} from "../../services/user.service";
import {PlanoService} from "../../services/plano.service";
import {Localiser} from "../../services/localiser";
import {ImagesService} from "../../services/images.service";
import {DeviceService} from "../../services/device.service";
import {MatDialog} from "@angular/material/dialog";
import {UploadComponent} from "./upload/upload.component";
import {DeleteFloorplanComponent} from "./delete-floorplan/delete-floorplan.component";
import {Roles} from '../../commons/util';
import {of} from "rxjs";
import {catchError, finalize} from "rxjs/operators";

@Component({
  selector: 'app-select-floorplan',
  templateUrl: './select-floorplan.component.html',
  styleUrls: ['./select-floorplan.component.css']
})
export class SelectFloorplanComponent implements OnInit {

  public planosReal: plano[] = [];
  public planos: plano[] = [];
  planosNumber: number = undefined;
  loadingPlanos: boolean = true;
  actualPage: number = 1;
  /*
    Identifies the current load, so responses of a load that was already
    replaced by a newer one (a dialog closing and calling init() again) are
    discarded instead of mixed into the list.
   */
  private loadId = 0;

  constructor(private navigation: Navigation, public proyectoService: ProyectoService,
              public planoService: PlanoService, public localiser: Localiser,
              private imagesService: ImagesService, public user: UserService,
              private deviceService: DeviceService, public matDialog: MatDialog,
              private  changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.init();
  }

  init() {
    if (!this.proyectoService.proyectoActualCookie()) {
      this.proyectoService.setTrueSelectALocation("floorplans");
      this.toLocations();
    } else {
      this.proyectoService.setLastPage("floorplans");
      this.getPlanos();
    }
  }

  getPlanos() {
    let loadId = ++this.loadId;
    this.loadingPlanos = true;
    this.planosReal = [];
    let idProyecto = this.proyectoService.getProyectoActual().idProyecto;

    /*
      The pages can only be asked for once the count is known, otherwise the
      count and the first page race each other and the spinner may be checked
      before planosNumber has any value.
     */
    this.planoService.getCountByIDProyecto(idProyecto).pipe(
      catchError(() => of(0))
    ).subscribe((result: number) => {
      if (loadId != this.loadId) {
        return;
      }
      this.planosNumber = Number(result) || 0;
      this.getPlanosPaginated(idProyecto, loadId);
    });
  }

  /*
    Ask for every page of the project and stop the spinner once all of them have
    answered, no matter whether they succeeded: a failed request or a count that
    does not match the rows actually returned must not leave it spinning.
   */
  getPlanosPaginated(idProyecto, loadId) {
    let totalPages = Math.max(1, Math.ceil(this.planosNumber / 7));
    let pages: Array<Array<plano>> = new Array(totalPages).fill(null);
    let pending = totalPages;

    for (let page = 0; page < totalPages; page++) {
      let requestedPage = page;
      this.planoService.getByIDProyectoPaginated(idProyecto, requestedPage).pipe(
        catchError(() => of([])),
        finalize(() => {
          pending--;
          if (pending == 0 && loadId == this.loadId) {
            this.loadingPlanos = false;
          }
        })
      ).subscribe((result: Array<plano>) => {
        if (loadId != this.loadId) {
          return;
        }
        pages[requestedPage] = result;
        this.planosReal = [].concat(...pages.filter(loadedPage => loadedPage != null));
        this.paginatePlanos(1, 7);
      });
    }
  }

  /*
    Show only 7 floorplans in the list
   */
  paginatePlanos(page, n) {
    if (page > Math.ceil(this.planosReal.length / n)) {
      page = Math.ceil(this.planosReal.length / n);
    }
    if (page < 1 || page == undefined) {
      page = 1;
    }
    this.actualPage = undefined;
    this.changeDetectorRef.detectChanges();
    this.actualPage = page;
    this.planos = this.planosReal.slice(n * (page - 1), n * page);
  }

  changePageByNumber(page) {
    if (page != undefined) {
      this.actualPage = undefined;
      this.changeDetectorRef.detectChanges();
      this.paginatePlanos(page, 7);
    }
  }

  outInputChangePageByNumber(event) {
    if (isNaN(event.srcElement.valueAsNumber)) {
      this.paginatePlanos(1, 7);
    }
  }

  changePageByArrow(nextPage: number) {
    this.paginatePlanos(this.actualPage + nextPage, 7);
  }

  isLastPage() {
    return Math.ceil(this.planosReal.length / 7) == this.actualPage || Math.ceil(this.planosReal.length / 7) <= 1;
  }

  openUploadFloorplan() {
    let dialog = this.matDialog.open(UploadComponent, {
      width: '60%',
      height: '70%'
    });

    dialog.afterClosed().subscribe(() => { this.init() } );
  }

  goToInfoPlano(plano: plano) {
    this.deviceService.setSelectedPlano(plano);
    this.navigation.toDevices();
  }

  selectPlano(plano: plano) {
    this.planoService.setPlanoSelected(plano);
    this.navigation.toFloorplans();
  }

  toLocations() {
    this.navigation.toLocations();
  }

  deleteFloorplan(floorplan) {
    let dialog = this.matDialog.open(DeleteFloorplanComponent, {
      width: '70%',
      height: '93%',
      data: {floorplan: floorplan, proyecto: this.proyectoService.getProyectoActual()}
    });

    dialog.afterClosed().subscribe(() => { this.init() } );
  }

  public readonly Roles = Roles;
}
